import startOfDay from 'date-fns/startOfDay';
import { RRule, rrulestr } from 'rrule';

export const newRRuleUntilDateForDelete = (rRuleStr: string, originalStartDate: Date, untilDate: Date) => {
	let rrule = rrulestr(`RRULE:${rRuleStr}`, { dtstart: new Date(originalStartDate) });
	rrule = new RRule({ ...rrule.options, count: undefined, until: startOfDay(new Date(untilDate)) });
	return rrule;
};
